import React from "react";
import CocardParticipantRedemptionTable from "./CocardParticipantRedemptionTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const CocardParticipantRedemptionIndex = () => (
  <ReportProgramsPage
    TableComponent={CocardParticipantRedemptionTable}
    loadingMessage="Loading Cocard participant redemption..."
  />
);

export default CocardParticipantRedemptionIndex;
